import { render, staticRenderFns } from "./ManageDepartmentTable.vue?vue&type=template&id=228ee02c&scoped=true&"
import script from "./ManageDepartmentTable.vue?vue&type=script&lang=js&"
export * from "./ManageDepartmentTable.vue?vue&type=script&lang=js&"
import style0 from "./ManageDepartmentTable.vue?vue&type=style&index=0&id=228ee02c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ee02c",
  null
  
)

export default component.exports